import React from "react";
import ReactTable from "react-table";
import withStyles from "@material-ui/core/styles/withStyles";
import flor_lis from "assets/img/flor_lis_placeholder.svg";
import wrapperStyle from "assets/jss/material-dashboard-pro-react/views/reactTableWrapperStyle";

import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ReactTableWrapper extends React.Component {

  render() {
    const {classes, data, placeholder, manual} = this.props;
    return [
      (data && data.length || manual) && <ReactTable
        PaginationComponent={Pagination}
        {...this.props}
        style={{...this.props.style, display: manual && data.length === 0 ? "none" : this.props.style && this.props.style.display}}
      />,
      !(data && data.length) && <div className={classes.placeHolderWrapper}>
        <img src={flor_lis} alt="logo" className={classes.placeHolderImg}/>
        {placeholder || "Sem dados disponíveis para apresentar."}
      </div>
    ]
  }
}

const defaultButton = props => <a className={"table_pagination_button"} style={{
  lineHeight: "1.25",
  position: "relative",
  marginLeft: "-1px",
  color: "#8898aa",
  borderColor: "rgb(222, 226, 230)",
  borderWidth: 1,
  borderStyle: "solid",
  backgroundColor: "#fff",
  fontSize: ".875rem",
  display: "flex",
  width: "36px",
  height: "36px",
  margin: "0 3px",
  padding: "0",
  borderRadius: "50%",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  ...(props.active && {
    zIndex: 1,
    color: "#fff",
    borderColor: "#009344",
    backgroundColor: "#009344",
    boxShadow: "0 7px 14px rgba(50, 50, 93, .1), 0 3px 6px rgba(0, 0, 0, .08)",
  })
}} {...props}>{props.children}</a>;

class Pagination extends React.Component {
  constructor(props) {
    super();

    this.changePage = this.changePage.bind(this);

    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages)
      });
    }

    this.changePage(nextProps.page + 1);
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages);
  };

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  };

  changePage(page) {
    const activePage = this.props.page + 1;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    });

    this.props.onPageChange(page - 1);
  }

  render() {
    const {PageButtonComponent = defaultButton} = this.props;
    const {visiblePages} = this.state;
    const activePage = this.props.page + 1;

    if (visiblePages.length < 2)
      return null;

    return (
      <div className="Table__pagination" style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginTop: 12,
        marginLeft: 20,
        marginRight: 20
      }}>
        <div className="Table__prevPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === 1) return;
              this.changePage(activePage - 1);
            }}
            disabled={activePage === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft}/>
          </PageButtonComponent>
        </div>
        <div className="Table__visiblePagesWrapper" style={{
          flexDirection: "row",
          display: "flex"
        }}>
          {visiblePages.map((page, index, array) => {
            return (
              <PageButtonComponent
                key={page}
                className={
                  activePage === page
                    ? "Table__pageButton Table__pageButton--active"
                    : "Table__pageButton"
                }
                active={activePage === page}
                onClick={this.changePage.bind(null, page)}
              >
                {array[index - 1] + 2 < page ? `...${page}` : page}
              </PageButtonComponent>
            );
          })}
        </div>
        <div className="Table__nextPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === this.props.pages) return;
              this.changePage(activePage + 1);
            }}
            disabled={activePage === this.props.pages}
          >
            <FontAwesomeIcon icon={faChevronRight}/>
          </PageButtonComponent>
        </div>
      </div>
    );
  }
}


export default withStyles(wrapperStyle)(ReactTableWrapper);